/*
 * HTML converter for Superscript.
 */
export default {
  type: 'superscript',
  tagName: 'sup'
}
